var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"selector-overlay-container",class:{
    'horizontal': _vm.horizontal,
  }},[_vm._t("default"),_c('SelectorOverlay',{ref:"overlay"})],2)}
var staticRenderFns = []

export { render, staticRenderFns }